import React from "react";
import { FormattedMessage } from "react-intl";
import { connect, useSelector } from "react-redux";

import {
  getDemValue,
  getGroundwaterLevelChart,
  getRainFallLevelChart,
  getWaterLevelChart,
} from "../state/selectedPoint";
import { Asset } from "../types/assets";

import CollapsableSidebarStyles from "./CollapsableSidebar.module.css";
import menuStyles from "./Menu.module.css";
import RightMenuHeader from "./RightMenuHeader";
import assetInspectorStyles from "./SelectedAssetInspector.module.css";
import TimeseriesChart from "./TimeseriesChart";

interface Props {
  asset: Asset | null;
  groundwaterAsset: Asset | null;
}

const SelectedPointInspector: React.FC<Props> = ({ asset, groundwaterAsset }) => {
  const demValue = useSelector(getDemValue);
  const waterLevelChart = useSelector(getWaterLevelChart);
  const groundwaterLevelChart = useSelector(getGroundwaterLevelChart);
  const rainFallLevelChart = useSelector(getRainFallLevelChart);
  const demHeight = useSelector(getDemValue);
  const waterDepthChart =
    (demHeight || demHeight === 0) && waterLevelChart
      ? waterLevelChart
          .map((item) => {
            return { ...item, value: item.value - demHeight };
          })
          .map((item) => (item.value > 0 ? item : { ...item, value: NaN }))
      : [];
  return (
    <div
      className={`${CollapsableSidebarStyles.LeftMenu} ${CollapsableSidebarStyles.LeftMenuPadChildDivs}`}
    >
      <RightMenuHeader
        titleElement={
          <FormattedMessage id="selectedPointInspector.headerTitle" defaultMessage="Point" />
        }
        parent={"POINT"}
      />
      <hr className={menuStyles.SeperatorLine} />
      {/* DEM value */}
      <div className={`${assetInspectorStyles.DetailList}`}>
        <div className={`${assetInspectorStyles.DetailListItem} ${assetInspectorStyles.KeyValue}`}>
          <FormattedMessage
            id="editRasterMenu.type_elevation_dem"
            defaultMessage="Elevation (DEM)"
          />
          <span>{demValue ? parseFloat(demValue.toFixed(2)) : null} m MSL</span>
        </div>
      </div>
      <hr className={menuStyles.SeperatorLine} />
      {/* waterlevel  */}
      {asset ? <TimeseriesChart asset={asset} data={waterLevelChart} type={"Waterlevel"} /> : null}
      {/* depth */}
      {asset ? <TimeseriesChart asset={asset} data={waterDepthChart} type={"WaterDepth"} /> : null}
      {/* rainfall */}
      {asset ? (
        <TimeseriesChart asset={asset} data={rainFallLevelChart} type={"RainfallOnPointChart"} />
      ) : null}
      {/* groundwater */}
      {groundwaterAsset ? (
        <TimeseriesChart
          asset={groundwaterAsset}
          data={groundwaterLevelChart}
          type={"GroundwaterLevel"}
        />
      ) : null}
    </div>
  );
};

export default connect(null, {})(SelectedPointInspector);
